var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatSocialTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52786 9.41738C6.17897 7.39096 9.28044 6.05503 10.8323 5.40957C15.2631 3.56666 16.1837 3.24652 16.7838 3.23595C16.9158 3.23363 17.2109 3.26634 17.4021 3.42145C17.5635 3.55242 17.6079 3.72934 17.6291 3.85352C17.6504 3.97769 17.6769 4.26057 17.6558 4.4816C17.4157 7.00441 16.3768 13.1266 15.8482 15.9522C15.6246 17.1478 15.1842 17.5487 14.7579 17.5879C13.8314 17.6732 13.1278 16.9756 12.2304 16.3874C10.8262 15.4669 10.0329 14.8939 8.66986 13.9957C7.09464 12.9576 8.11579 12.3871 9.01351 11.4547C9.24845 11.2107 13.3307 7.49754 13.4097 7.1607C13.4196 7.11857 13.4288 6.96154 13.3355 6.87862C13.2422 6.7957 13.1045 6.82406 13.0051 6.84661C12.8643 6.87857 10.621 8.36128 6.27537 11.2947C5.63863 11.732 5.06189 11.945 4.54515 11.9338C3.97548 11.9215 2.87968 11.6117 2.06506 11.3469C1.06589 11.0222 0.271779 10.8504 0.340929 10.2988C0.376946 10.0115 0.772589 9.71772 1.52786 9.41738Z",
    fill: "#DD5800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatSocialTelegram);
export default __webpack_public_path__ + "static/media/sat_social_telegram.f5ee8bd8f1aff7f4cd7dc8189029a404.svg";
export { ForwardRef as ReactComponent };